/**
 * @desc 查询年实际产品销量与销价
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.YearRequest,
): Promise<
  defs.StandardReturn<
    defs.ObjectMap<string, defs.QueryPlanSaleYearActualResponse>
  >
> {
  return defHttp.post({
    url: '/web/sale/year/queryYearActualSaleAndPrice',
    data,
  });
}

export function mock(
  data: defs.YearRequest,
): Promise<
  defs.StandardReturn<
    defs.ObjectMap<string, defs.QueryPlanSaleYearActualResponse>
  >
> {
  return defHttp.post({
    url: '/mock/web/sale/year/queryYearActualSaleAndPrice',
    data,
  });
}
